<template>
  <div class="help-box" @click="toggle">
    <div class="d-flex justify-content-between align-items-center">
      <span class="title">{{ title }}</span> 
      <i class="fa" aria-hidden="true" :class="isExpanded ? 'fa-angle-up' : 'fa-angle-down'" style="font-size:24px"></i>
    </div>
    <p class="text-semimuted" v-if="isExpanded">{{ paragraph }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      paragraph: {
        type: String,
        required: true
      },
      expanded: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isExpanded: this.expanded
      }
    },
    methods: {
      toggle () {
        this.isExpanded = !this.isExpanded
        if (this.isExpanded) this.$emit('expanded')
      }
    },
  }
</script>

<style lang="less">
  .help-box {
    cursor: pointer;
  }
</style>